'use strict';

import redirectTemplate from './decipherSurveyRedirect.html';
import {
    find,
    forIn,
    forOwn,
    parseInt
} from 'lodash';

var decipherSurveyRedirectController = function ($controller, $location, $state, workflowService) {
    var vm = this;
    vm.executionStep = null;
    angular.extend(vm, $controller('baseStepController'));

    vm.$onInit = function () {

        switch (vm.surveyStatus) {
            case 'terminate':
            case 'overquota':
                abortSurvey();
                break;
            default:
                completeSurvey();
        }
    }

    function completeSurvey() {
        workflowService.getTicketStep(vm.ticketId, vm.stepId).then(function (ticketStep) {
            vm.executionStep = { ticketStep: ticketStep };
            vm.setExecutionStep(vm.executionStep);
            var params = getDecipherParameters();
            setParameters(params);
            vm.transition();
        });
    }

    function setParameters(results) {
        forIn(results, function (value, key) {

            //match property name to parameter global name
            var existing = find(vm.executionStep.ticketStep.parameters, function (p) {
                return p.globalName.toLowerCase() === key.toLowerCase();
            })

            //update value or add a new parameter
            if (existing) {
                existing.value = value;
            } else {
                vm.executionStep.ticketStep.parameters.push({
                    globalName: key,
                    value: value
                });
            }
        });
    }

    function abortSurvey() {
        $state.go('completeTicket', {
            ticketId: vm.ticketId,
            status: vm.surveyStatus
        });
    }

    function getDecipherParameters() {
        var parameters = $location.search();

        //translate droppoint (1-based index to 0-based index)
        forOwn(parameters, (value, key, obj) => {
            if (key.toLowerCase() === 'droppoint') {
                var dropPoint = parseInt(value);
                if (dropPoint !== 0) dropPoint--;
                obj[key] = dropPoint;
            }
        });

        return parameters;
    }
}

decipherSurveyRedirectController.$inject = ['$controller', '$location', '$state', 'workflowService'];

export var decipherSurveyRedirectComponent = {
    name: 'decipherSurveyRedirect',
    template: redirectTemplate,
    controller: decipherSurveyRedirectController,
    bindings: {
        surveyStatus: '@',
        ticketId: '@',
        stepId: '@'
    }
};

export var decipherSurveyRedirectRoute = {
    name: 'decipherSurveyRedirect',
    url: '/decipherRedirection/{surveyStatus}/{ticketId}/{stepId}',
    component: 'decipherSurveyRedirect',
    resolve: {
        surveyStatus: ['$transition$', function ($transition$) {
            return $transition$.params().surveyStatus;
        }],
        ticketId: ['$transition$', function ($transition$) {
            return $transition$.params().ticketId;
        }],
        stepId: ['$transition$', function ($transition$) {
            return $transition$.params().stepId;
        }]
    }
};